/*global analytics*/
import React, { Component } from "react";
import { Helmet } from "react-helmet";

export default class ShareFacebookMessenger extends Component {

    handleClick = () => {
        let myBoxLink = this.props.url;
        let app_id = 246587655398427;
        let androidMessengerDownloadLink = 'market://details?id=com.facebook.orca'
        let iosMessengerDownloadLink = "itms://itunes.apple.com/us/app/messenger/id454638411?mt=8";
        let installedShareLink = `fb-messenger://share?link=${encodeURIComponent(myBoxLink)}&app_id=${encodeURIComponent(app_id)}`;

        var now = new Date().valueOf();
        setTimeout(() => {
            if (new Date().valueOf() - now > 100) return;
            if(this.isAndroid()){
                window.location = androidMessengerDownloadLink;
            } else {
                window.location = iosMessengerDownloadLink;
            }
        }, 50);
        window.location = installedShareLink;

        analytics.track('Clicked Element', {
            element_name: 'Facebook Messenger Share'
        });
    }

    isAndroid = () => {
        let userAgent = navigator.userAgent || navigator.vendor || window.opera;
        if (/android/i.test(userAgent)) {

            return true;
        }
        return false;
    }

    render(){
        if(this.props.isMobile){
            return (
                <React.Fragment>
                    <Helmet>
                        <script src="https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v3.0" id="facebook-jssdk"></script>
                    </Helmet>
                    <div 
                        className="smb__icon smb__icon--facebookMessenger" 
                        onClick={this.handleClick}
                        title="Share on Facebook Messenger"
                    >
                        <i className="fab fa-facebook-messenger"></i>
                    </div>
                </React.Fragment>

            )
        } else {
            return null;
        }
    }
}



// WEBPACK FOOTER //
// ./src/Components/ShareMyBox/ShareFacebookMessenger/ShareFacebookMessenger.js